import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class FulfillmentDisplayStatusDisplayListComponent implements IController {
  ids: any;
  isRow: any;
  onChange: Function;

  constructor() {
  }

  $onInit() {
  }

  $onChanges(changes) {
    if (changes.ids) {
      this.$onInit();
    }
  }

  onRemove(id) {
    this.onChange({ids: _.filter(this.ids, (i) => {return i !== id})});
  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentDisplayStatusDisplayList', {
    bindings: {
      ids: '<',
      isRow: '<?',
      onChange: '&'
    },
    template: require('./fulfillment-display-status-display-list.html').default,
    controller: FulfillmentDisplayStatusDisplayListComponent
  });
